import { FaFilter } from "react-icons/fa";
import { Button, Dropdown, Form } from "react-bootstrap";
import ReactDOM from "react-dom";
import './CustomFilterDropdown.css';
import { useEffect, useRef, useState } from "react";

const Portal = ({ children }) => {
  return ReactDOM.createPortal(children, document.body);
};


const computePosition = (anchorRect, menuWidth, menuHeight, gap = 8) => {
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    // Try below
    let top = anchorRect.bottom + gap;
    let left = anchorRect.left;

    // If overflowing right, align menu's right edge to anchor's right edge
    if (left + menuWidth > vw - 8) {
        left = Math.max(8, anchorRect.right - menuWidth);
    }

    // If bottom overflows, show above
    if (top + menuHeight > vh - 8) {
        top = anchorRect.top - menuHeight - gap;
    }

    // If still off top, clamp
    top = Math.max(8, top);
    left = Math.max(8, left);

    return { top, left };
};

const ColumnFilter = ({ value, onChange, placeholder }) => {
    const toggleRef = useRef(null);
    const menuRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [pos, setPos] = useState({ top: 0, left: 0, width: 240 });

    const isActive = value && value.trim() !== "";

    // open/close toggle
    const toggle = (e) => {
        e.stopPropagation();
        const anchor = toggleRef.current;
        if (!anchor) return setOpen(false);

        // compute approx menu size: width fixed, height measured after render
        const menuWidth = 260; // default width
        // temporarily open, then compute actual height on next tick
        setOpen((prev) => !prev);
        // position will be computed in effect when menuRef exists
    };

    // compute and set position after menu mounts or window resizes/scrolls
    useEffect(() => {
        if (!open) return;

        const anchor = toggleRef.current;
        const menu = menuRef.current;
        if (!anchor || !menu) return;

        const anchorRect = anchor.getBoundingClientRect();

        // measure menu (set invisibly first if needed)
        const menuRect = menu.getBoundingClientRect();
        const menuWidth = Math.max(menuRect.width || 260, 240);
        const menuHeight = menuRect.height || 140;

        const { top, left } = computePosition(anchorRect, menuWidth, menuHeight, 8);
        setPos({ top, left, width: menuWidth });

        const handleScrollResize = () => {
            const r = anchor.getBoundingClientRect();
            const { top: nt, left: nl } = computePosition(r, menuWidth, menuHeight, 8);
            setPos({ top: nt, left: nl, width: menuWidth });
        };

        window.addEventListener("scroll", handleScrollResize, true);
        window.addEventListener("resize", handleScrollResize);
        const onDocClick = (ev) => {
            if (menu && !menu.contains(ev.target) && anchor && !anchor.contains(ev.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", onDocClick);

        return () => {
            window.removeEventListener("scroll", handleScrollResize, true);
            window.removeEventListener("resize", handleScrollResize);
            document.removeEventListener("mousedown", onDocClick);
        };
    }, [open]);

    // prevent page scroll when using keyboard inside input? (optional)
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => {
            if (e.key === "Escape") setOpen(false);
        };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open]);


    // return (
    //     <Dropdown className="column-filter-dropdown" align="end">
    //         <Dropdown.Toggle
    //             variant="light"
    //             size="sm"
    //             className="p-1 border-0 bg-transparent"
    //             style={{ boxShadow: "none" }}
    //         >
    //             <FaFilter size={14} />
    //         </Dropdown.Toggle>

    //         <Dropdown.Menu
    //             style={{ minWidth: "220px", padding: "10px", zIndex: 9999 }}
    //         >
    //             <strong>{placeholder}</strong>
    //             <Form.Control
    //                 className="mt-2"
    //                 placeholder={`Filter ${placeholder}`}
    //                 value={value}
    //                 onChange={(e) => onChange(e.target.value)}
    //             />
    //             <div className="d-flex justify-content-end mt-2">
    //                 <Button size="sm" variant="outline-secondary" onClick={() => onChange("")}>
    //                     Clear
    //                 </Button>
    //             </div>
    //         </Dropdown.Menu>
    //     </Dropdown>
    // )

    return (
        <>
        <button
            ref={toggleRef}
            className="filter-toggle-btn"
            onClick={toggle}
            aria-label={`Open ${placeholder} filter`}
            type="button"
            style={{
                color: isActive ? "#002355" : "#6c757d",  // 🔥 blue when active, gray when inactive
                fontWeight: isActive ? "700" : "400"
            }}
        >
            <FaFilter />
        </button>

        {open && (
            <Portal>
            <div
                ref={menuRef}
                className="custom-filter-menu"
                style={{
                    position: "fixed",
                    top: pos.top,
                    left: pos.left,
                    minWidth: pos.width,
                    zIndex: 2147483647
                }}
            >
                <div className="menu-header"><strong>{placeholder}</strong></div>

                <div className="menu-body">
                <Form.Control
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    autoFocus
                />
                </div>

                <div className="menu-actions">
                    <Button 
                        size="sm" 
                        variant="outline-secondary" 
                        onClick={() => {
                            onChange("");
                            setOpen(false); // close dropdown
                        }}
                    >
                        Clear
                    </Button>
                    <Button 
                        size="sm" 
                        variant="primary" 
                        onClick={() => setOpen(false)}
                    >
                        Done
                    </Button>
                </div>
            </div>
            </Portal>
        )}
        </>
    );
};

export default ColumnFilter;
